import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Candidatura } from '../models/candidatura.model';
import { RelatorioPreCandidato } from '../models/relatorioPreCandidato.model';


@Injectable({
  providedIn: 'root'
})
export class CandidaturaService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }
    
   listarPorIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/candidaturas/eleicao/${idEleicao}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public getRelatorioPreCandidatos(idCandidatura: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get<RelatorioPreCandidato>(`${environment.url_api}/precandidatos/${idCandidatura}/gerar-relatorio-precandidaturas`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public salvarCandidatura(candidatura: Candidatura, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/candidaturas`, candidatura, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  public editarCandidatura(idCandidatura: number, candidatura: Candidatura, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.put(`${environment.url_api}/candidaturas/${idCandidatura}`, candidatura, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }

  public editarCandidaturaQtAprovadores(idCandidatura: number, qtAprovadores: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.put(`${environment.url_api}/candidaturas/qtAprovadores/${idCandidatura}?qtAprovadores=${qtAprovadores}`, {}, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }


  public getExecInicioCandidaturasAuto (tokenParam: any){

    return new Promise((resolve,reject)=>{
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.get(`${environment.url_api}/candidaturas/execInicio`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public getExecInicioAprovacaoAuto (tokenParam: any){

    return new Promise((resolve,reject)=>{
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.get(`${environment.url_api}/candidaturas/execInicioAprovacao`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  
  
}
